import { useCallback, useEffect, useState } from 'react';
import { PortalPage } from './portalApi';
import { portalErrorMessage } from './portalHttp';

// ---- P1-B customer portal: paged list loader shared by the list pages ----
export function usePortalList<T>(fetcher: (page: number, size: number) => Promise<PortalPage<T>>, deps: unknown[] = []) {
  const [page, setPage] = useState(0);
  const [size, setSize] = useState(20);
  const [data, setData] = useState<PortalPage<T> | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const run = useCallback(fetcher, deps);
  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    run(page, size)
      .then(d => { if (!cancelled) { setData(d); setError(null); } })
      .catch(e => { if (!cancelled) setError(portalErrorMessage(e, 'Could not load this list')); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [run, page, size]);

  return { page, setPage, size, setSize, data, error, loading };
}
// ---- end P1-B ----
